import * as React from "react";
import Input from "../Input-new/Input";
import Textarea from "../Textarea-new/Textarea";
import Dropdown from "../Dropdown/Dropdown";
import SelectFirm from "../SelectFirm/SelectFirm";
import OpenInCrmButton from "../OpenInCrmButton/OpenInCrmButton";
import { formatDateUSA } from "../../utils";
import { useVendorTypes, subtypesOf } from "../../vendor-types";

/**
 * The most recent note, shown read-only; the modal behind Show Notes has them
 * all. Notes carried over from the old single NOTES box have no date, so `when`
 * is empty for those rather than invented.
 */
function latestNote(notes) {
  if (!notes || !notes.length) return null;

  const note = notes[0];
  const text = (note.NOTE_TEXT || '').trim();

  if (!text) return null;

  const stamped = formatDateUSA(note.DATE_CREATED, true);
  const who = (note.CREATED_BY || '').trim();
  const when = stamped ? stamped.replace(' ', ', ') + (who ? ` - ${who}` : '') : '';

  return { when, text };
}

const VendorInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
  isExists,
  notes,
  onShowNotes,
}) => {
  const hasLeadId = Boolean(data.LEAD_ID);
  const latest = latestNote(notes);
  const vendorTypes = useVendorTypes();
  const subtypes = subtypesOf(vendorTypes, data.VENDOR_TYPE);

  return (
    <div className="vendor-info">
      <div className="vendor-info_column">
      {(isExists) && <p className="errorText"> Given Vendor Details Already Exists</p>} 

        
        <Dropdown
            className="vendor-info_column_item"
            data={data}
            optionsType="vendorType"
            options={vendorTypes.map((type) => type.NAME)}
            value={data.VENDOR_TYPE}
            valueKey="VENDOR_TYPE"
            label="Vendor Type"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted} />
        {(subtypes.length > 0 || Boolean(data.VENDOR_SUBTYPE)) && (
          <Dropdown
              className="vendor-info_column_item"
              data={data}
              optionsType="vendorSubtype"
              options={subtypes}
              value={data.VENDOR_SUBTYPE}
              valueKey="VENDOR_SUBTYPE"
              label="Subtype"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted} />
        )}
        <Input className="vendor-info_column_item"
            valueType='text'
            name='FIRST_NAME'
            label='First Name'
            value={data.FIRST_NAME}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input className="vendor-info_column_item"
            valueType='text'
            name='LAST_NAME'
            label='Last Name'
            value={data.LAST_NAME}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="vendor-info_column_item"
            valueType="phone"
            name="PHONE"
            label="Cell Phone"
            value={data.PHONE}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
            className="vendor-info_column_item"
            valueType="phone"
            name="WORK_PHONE"
            label="Work Phone"
            value={data.WORK_PHONE}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
        />
        <Input
          className="vendor-info_column_item"
          valueType="email"
          name="EMAIL_ID"
          label="Email"
          value={data.EMAIL_ID}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="vendor-info_column_item"
          valueType="text"
          name="WEBSITE"
          label="Website"
          value={data.WEBSITE}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <SelectFirm
          className="vendor-info_column_item"
          value={data.FIRM_ID}
          valueKey="FIRM_ID"
          label="Firm"
          firmName={data.FIRM_NAME || data.COMPANY_NAME}
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
          searchAddress
          canAddFirm
        />
        <Input
          className="vendor-info_column_item"
          valueType="text"
          name="LEAD_ID"
          label="Lead ID"
          value={data.LEAD_ID}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        {hasLeadId && (
          <div style={{
            marginTop: '12px',
            padding: '12px 16px',
            backgroundColor: '#e8f5e9',
            borderRadius: '8px',
            border: '1px solid #c8e6c9'
          }}>
            <OpenInCrmButton leadId={data.LEAD_ID} entityType="account" />
          </div>
        )}
        <div className="vendor-info_notes">
          <span className="vendor-info_notes-label">Notes</span>
          {latest ? (
            <React.Fragment>
              {latest.when && <p className="vendor-info_notes-stamp">{latest.when}</p>}
              <p className="vendor-info_notes-text">{latest.text}</p>
            </React.Fragment>
          ) : (
            <p className="vendor-info_notes-text vendor-info_notes-empty">-</p>
          )}
          <button
            type="button"
            className="vendor-info_show-notes-btn"
            onClick={onShowNotes}
          >
            Show Notes
          </button>
        </div>
    </div>
        
    </div>
  );
};

export default VendorInfo;
